<div [ngClass]="{'form-group': includeFormGroup}" [ngStyle]="{display: (includeFormGroup ? 'block' : 'inline')}">
	<div class="custom-control custom-checkbox" (click)="inputValue = !inputValue; updateFormInputValue()">
		<input type="checkbox" class="custom-control-input" [checked]="inputValue" [name]="checkboxName" />
		<label class="custom-control-label">{{label}}</label>
	</div>
	<app-form-help-text *ngIf="helpText" [helpText]="helpText"></app-form-help-text>
</div>